import { P2GBox } from '@parcel2go/core-ui';

import { SvgParcel } from '@parcel2go/core-ui';

import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { GenerateSourceSquareUrlFromId } from '../../../lib/helpers/SourceUrlHelper';
import P2GConditionalImage from '../../P2GConditionalImage';
import P2GContentDropDown from '../../P2GContentDropDown';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  item: SmartSendItemApiModel;
}

const Image = (props: props) => {
  const img = props.item.MarketplaceOrderLines[0]?.Product?.ImageUrl;
  const sourceId = props.item.MarketplaceOrderLines[0]?.Source?.Id;

  if (img) {
    return (
      <P2GContentDropDown
        control={<P2GConditionalImage style={{ height: '75px', maxWidth: '100%' }} src={img} alt="Image" />}
      >
        <P2GConditionalImage style={{ height: '350px', maxWidth: '350px' }} src={img} alt="Image" />
      </P2GContentDropDown>
    );
  }

  if (!sourceId || ['csv', 'manual', 'grouped'].includes(sourceId)) {
    return (
      <CdnIconProxy palette="primary" src="/theme/icons/Parcel.svg">
        <SvgParcel />
      </CdnIconProxy>
    );
  }

  return <P2GConditionalImage style={{ height: '50px' }} src={GenerateSourceSquareUrlFromId(sourceId)} alt="Logo" />;
};

export default function ItemAvatar(props: props & { size?: number }) {
  return (
    <P2GBox bordered textAlign="center">
      <div
        style={{
          overflow: 'hidden',
          height: `${props.size ?? 55}px`,
          lineHeight: `${props.size ?? 55}px`,
          border: '5px solid white'
        }}
      >
        <Image item={props.item} />
      </div>
    </P2GBox>
  );
}
